// extracted by mini-css-extract-plugin
export var deliveryRow = "_ld-a";
export var fixedHeight = "_ld-4";
export var freightLogo = "_ld-9";
export var fullWidth = "_ld-3";
export var priceColumn = "_ld-5";
export var radioSelected = "_ld-7";
export var radioUnselected = "_ld-6";
export var selectedOption = "_ld-2";
export var selectedOptionContainer = "_ld-1";
export var selection = "_ld-0";
export var tallSkeletonText = "_ld-8";